import { postAPI } from "../../../../api/apis"
import { REACT_APP_CANDIDATE_FREELANCER  } from "../../../../utils/common"

export async function getJobsForCandidate(body: any) {
    const loginId = localStorage.getItem('loginId') || ''
    const Details = postAPI( REACT_APP_CANDIDATE_FREELANCER + `/job-dashboard?candidateId=${loginId}`, body)
    return Details
}
